import { useEffect, useState } from 'react'

export const useScript = (url: string, onLoad: Function) => {
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    const handleLoad = () => {
      setLoaded(true)
      onLoad()
    }
    const script = document.createElement('script')
    script.src = url
    script.addEventListener('load', handleLoad)

    document.body.appendChild(script)

    return () => {
      script.removeEventListener('load', handleLoad)
    }
  }, [url])
  return loaded
}
